
import { Inject, Injectable, DOCUMENT } from "@angular/core";
import { LoggerService } from "./logger.service";

declare let gtag: any;
declare let dataLayer: any;

@Injectable({
  providedIn: "root"
})
export class GtmInjectionService {
  private readonly gtmId = 'GTM-5FQ832N';
  private isGtmLoaded = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private loggerService: LoggerService
  ) { }

  /**
   * Dynamically injects Google Tag Manager scripts into the page
   * This method should be called early in the app lifecycle (e.g., app.component.ts ngOnInit)
   */
  public injectGtm(): void {
    if (this.isGtmLoaded) {
      this.loggerService.verbose("GTM already loaded, skipping injection");
      return;
    }

    try {
      // Step 1: Initialize dataLayer
      const win = this.document.defaultView as any;
      win.dataLayer = win.dataLayer || [];
      win.gtag = function() {
        win.dataLayer.push(arguments);
      };
      win.gtag('js', new Date());
      win.gtag('config', this.gtmId);

      // Step 2: Inject gtag.js script
      const gtagScript = this.document.createElement('script');
      gtagScript.async = true;
      gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${this.gtmId}`;
      this.document.head.appendChild(gtagScript);

      // Step 3: Inject GTM script
      const gtmScript = this.document.createElement('script');
      gtmScript.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${this.gtmId}');
      `;
      this.document.head.appendChild(gtmScript);

      // Step 4: Inject GTM noscript iframe into body (for no-JS fallback)
      const noscript = this.document.createElement('noscript');
      noscript.innerHTML = `
        <iframe src="https://www.googletagmanager.com/ns.html?id=${this.gtmId}"
          height="0" width="0" style="display:none;visibility:hidden"></iframe>
      `;
      this.document.body.insertBefore(noscript, this.document.body.firstChild);

      this.isGtmLoaded = true;
      this.loggerService.verbose("Google Tag Manager injected successfully");
    } catch (error) {
      this.loggerService.error("Failed to inject Google Tag Manager", error);
    }
  }

  /**
   * Checks if GTM has been loaded
   */
  public isLoaded(): boolean {
    return this.isGtmLoaded;
  }
}
